import i18next from "i18next";
import { parseLocale } from "./parseLocale";

export function getCurrentLocale() {
  return parseLocale(i18next.language);
}
